import { schema } from 'normalizr';
import { clientSchema } from './clients';
import { jobSchema } from './jobs';

export const invoiceSchema = new schema.Entity('invoices', {
  jobs: [jobSchema],
  client: clientSchema,
})
